export const LANGUAGE_MULTI_SELECT_TRANSLATION_DE = {
  de: 'Deutsch',
  en: 'Englisch',
  fr: 'Französisch',
  el: 'EL',
  it: 'Italienisch',
  pl: 'Polnisch',
  pt: 'Portugiesisch',
  ru: 'Russisch',
  es: 'Spanisch',
  tr: 'Türkisch',
  ar: 'Arabisch',
  bg: 'Bulgarisch',
  zh: 'ZH',
  da: 'DA',
  et: 'Äthiopisch',
  fi: 'Finnisch',
  ga: 'GA',
  hr: 'Kroatisch',
  ku: 'KU',
  lv: 'Lettisch',
  lt: 'Litauisch',
  mt: 'Maltesisch',
  nl: 'Niederländisch',
  no: 'Norwegisch',
  ro: 'Rumänisch',
  sr: 'Suriname',
  sv: 'SV',
  sk: 'Slowakisch',
  sl: 'Slowenisch',
  cs: 'Serbisch',
  hu: 'Ungarisch',
  vi: 'VI',
} as const;
